<template>
  <div class="user-agreement">
    <!-- <h1>用户协议</h1> -->
    <iframe src="/用户协议2.html" frameborder="0" width="100%" height="800px"></iframe>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement'
}
</script>

<style scoped>
.user-agreement {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

h1 {
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}

iframe {
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style> 